import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';

import { useTranslation } from 'react-i18next';

import { dialogSx } from './styles';

export default function ExpiredMission ({ show, onClose }: { show: boolean; onClose: () => void; }) {
  const { t } = useTranslation();
  return (
    <Dialog open={show} sx={dialogSx}>
      <DialogTitle>{t('Reminder')}</DialogTitle>
      <DialogContent>
        <div className="message">{t('This mission is time over. Please contact the admin re-open.')}</div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('Close')}</Button>
      </DialogActions>
    </Dialog>
  );
}
